import { useContext } from 'react'

import { SignupContext } from './context'

export function useSignupForm() {
  const ctx = useContext(SignupContext)
  if (!ctx)
    throw new Error('useSignupForm must be used within SignupFormProvider')
  return ctx
}
